import React, { useEffect, useState } from 'react'
import {
  Box,
  TableCell,
  makeStyles,
  withStyles,
  TableBody,
  Link,
  TableRow,
  Table,
  TableHead,
  Button,
  Tab
} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import EditIcon from '@material-ui/icons/Edit'
import { HighlightOff } from '@material-ui/icons'
import moment from 'moment'
import { useParams } from 'react-router'
import NoRecordImg from '../../images/norecord.png'
import { DoctorStore } from '../../stores'
import { DOCTOR_USER_ID } from '../../Constants'
import AddMedicationModal from './AddMedicationModal'
import EditMedicationModal from './EditMedicationModal'
import AddLabOrders from './AddLabOrders'
import EditLabOrders from './EditLabOrders'
import ViewLabRecordModal from './ViewLabRecordModal'
import SnackbarAlert from '../CommonComponents/SnackbarAlert'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import jwt_decode from 'jwt-decode'
import { Pagination, TabContext, TabList, TabPanel } from '@material-ui/lab'
import { getLab, getPresignedURL } from '../../helper'

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#fff',
    color: 'rgba(55,55,55,0.8)',
    fontFamily: 'Poppins',
    fontSize: '14px',
    padding: '7px 10px !important'
  },
  tbody: {
    color: '#3f4b79',
    fontFamily: 'Poppins',
    '& td': {
      color: '#111d4e'
    },
    '& th': {
      fontSize: '0.8rem',
      fontFamily: 'Poppins',
      fontWeight: '500'
    }
  }
}))(TableCell)

const StyledTableRow = withStyles(() => ({
  root: {
    '&:nth-of-type(even)': {
      fontFamily: 'Poppins',
      backgroundColor: '#F5F5F5',
      color: '#000'
    },
    '& th': {
      fontSize: '14px',
      border: 0
    },
    '& td': {
      fontSize: '14px',
      border: 0
    }
  }
}))(TableRow)

//? Main Function
const Medication = props => {
  const classes = useStyles()
  const params = useParams()
  const disabled = props.disabled
  const [addModal, setAddModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [addLab, setAddLab] = useState(false)
  const [selectedMedication, setSelectedMedication] = useState({})
  const [selectedLab, setSelectedLab] = useState({})
  const [showEditLabModal, setShowEditLabModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState('')
  const [viewRecordModal, setViewRecordModal] = useState(false)
  const [alertOpen, setAlertOpen] = useState(false)
  const [snackBarMessage, setSnackBarMessage] = React.useState('')
  const [isSnackBarOpen, setOpenSnackBar] = React.useState(false)
  const [multiButton, setmultiButton] = React.useState(false)
  const [alertType, setAlertType] = React.useState('success')
  const [deleteMed, setDeleteMed] = useState('')
  const [labRecords, setLabRecords] = useState([])
  const [statusText, setStatusText] = useState('')
  const [statusTitle, setStatusTitle] = useState('')
  const [labs, setLabs] = useState([])
  const [prescriptions, setPrescription] = useState([])
  const [value, setValue] = useState('1')
  const [lcPage, setLcPage] = useState('1')
  const [lcTotalPage, setLcTotalPage] = useState('')
  const [presPage, setPresPage] = useState('1')
  const [presTotal, setPresTotal] = useState('')
  const [presigned, setPresigned] = useState('')

  const {
    medications,
    oldMedications,
    // labs,
    networkStatus,
    medicationsListStatus,
    labRecordsListStatus
  } = DoctorStore.useStoreState(state => ({
    ...state.patients
  }))
  const { getPatientMedications, deleteLab, deleteMedication } =
    DoctorStore.useStoreActions(actions => ({
      ...actions.patients
    }))

  const {
    currentMedicationsPage,
    oldMedicationsPage,
    totalPagesCurrent,
    totalPagesHistory
  } = DoctorStore.useStoreState(state => ({
    ...state.patients
  }))

  const { setCurrentMedicationsPage, setOldMedicationsPage } =
    DoctorStore.useStoreActions(actions => ({
      setCurrentMedicationsPage: actions.patients.setCurrentMedicationsPage,
      setOldMedicationsPage: actions.patients.setOldMedicationsPage
    }))

  const addMedicationClicked = () => {
    setAddModal(true)
  }
  const addLabOrdersClicked = () => {
    setAddLab(true)
  }
  const onPaginationClick = (event, value) => {
    setCurrentMedicationsPage(value)
  }
  const onPaginationHM = (event, value) => {
    setOldMedicationsPage(value)
  }

  const onLabPagination = (event, value) => {
    setLcPage(value)
  }
  const onPresPageChange = (event, value) => {
    setPresPage(value)
  }
  useEffect(() => {
    getPatientMedications({
      patientId: params.patient_id,
      page: currentMedicationsPage,
      filter: 'CURRENT'
    })
  }, [currentMedicationsPage])

  useEffect(() => {
    getPatientMedications({
      patientId: params.patient_id,
      page: oldMedicationsPage,
      filter: 'HISTORY'
    })
  }, [oldMedicationsPage])

  const fetchLabData = async () => {
    const resp = await getLab({
      pd_id: localStorage.getItem('pd_id'),
      appointement_id: params.appointement_id,
      doc_type: 'LAB',
      sort: 'DESC',
      table_config_page_no: lcPage,
      table_config_rows_per_page: 15
    })

    if (resp.success) {
      setLabs(resp.data.body)
      setLcTotalPage(resp.data.total_pages_count)
    } else {
      console.error('Failed to fetch lab data:', resp.error)
    }
  }

  useEffect(() => {
    fetchLabData()
  }, [lcPage])

  useEffect(() => {
    const prescriptionData = async () => {
      const resp = await getLab({
        pd_id: localStorage.getItem('pd_id'),
        appointement_id: params.appointement_id,
        doc_type: 'PRESCRIPTION',
        sort: 'DESC',
        table_config_page_no: presPage,
        table_config_rows_per_page: 15
      })

      if (resp.success) {
        setPrescription(resp.data.body)
        setPresTotal(resp.data.total_pages_count)
      } else {
        console.error('Failed to fetch lab data:', resp.error)
      }
    }

    prescriptionData()
  }, [])

  const deleteClicked = medication => {
    setSelectedMedication(medication)
    setAlertOpen(true)
    setStatusTitle('Delete Medication')
    setStatusText(
      `Do you want to delete the Drug Name : ${medication?.proprietaryname} ?`
    )
    setDeleteMed(true)
  }

  const editClicked = medication => {
    setSelectedMedication(medication)
    setEditModal(true)
  }

  const labEditClicked = lab => {
    setSelectedLab(lab)
    setShowEditLabModal(true)
  }

  useEffect(() => {
    if (labs) {
      setLabRecords(labs)
    }
  }, [labs])

  const labDeleteClicked = lab => {
    setSelectedLab(lab)
    setAlertOpen(true)
    setStatusTitle('Delete Lab Record')
    setStatusText(`Do you want to delete the Test name : ${lab?.testname}?`)
    setDeleteMed(null)
  }

  const viewLabClicked = async record => {
    const fileURL = await getPresignedURL(record)
    if (fileURL) {
      setSelectedRecord(fileURL)
      setViewRecordModal(true)
    }
  }

  const showSnackBar = () => {
    setOpenSnackBar(true)
  }

  const hideSnackBar = () => {
    setOpenSnackBar(false)
  }
  const handleAlertClose = () => {
    setAlertOpen(false)
  }
  const validationCheck = () => {
    setAlertOpen(false)
    if (deleteMed) {
      deleteMedication({
        medicationId: selectedMedication.id,
        patientId: params.patient_id
      })
    } else {
      deleteLab({
        labId: selectedLab.labs_id,
        patientId: params.patient_id,
        doctor_id: localStorage.getItem(DOCTOR_USER_ID)
      })
      setLabRecords([])
    }
    setOpenSnackBar(false)
  }

  let Lab_data = labRecords.sort((a, b) => {
    return new Date(b.prescribed_on) - new Date(a.prescribed_on)
  })

  var decoded = jwt_decode(localStorage.getItem('doctor_auth_key'))
  localStorage.setItem('is_doctor', JSON.stringify(decoded))

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const getTagValue = (tags, key) =>
    tags.find(tag => tag.key.toLowerCase() === key.toLowerCase())?.value || '-'

  return (
    <>
      <Box className={classes.InfoColTop}>
        <h3
          style={{
            marginTop: '30px',
            fontSize: 20,
            fontWeight: 500,
            color: '#000'
          }}>
          Current Medications
        </h3>
        {JSON.parse(localStorage.getItem('is_doctor'))?.is_doctor && (
          <button
            disabled={disabled}
            className={disabled ? classes.DisabledAddBtn : classes.AddBtn}
            onClick={addMedicationClicked}>
            Add New
          </button>
        )}
      </Box>
      <SnackbarAlert
        isOpen={isSnackBarOpen}
        message={snackBarMessage}
        alertType={alertType}
        multibutton={multiButton}
        primaryClick={hideSnackBar}
      />
      <Dialog
        open={alertOpen}
        onClose={handleAlertClose}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">{statusTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{statusText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleAlertClose} color="primary">
            Cancel
          </Button>
          <Button onClick={validationCheck} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell
              style={{
                width: '22%',
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Drug Name
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Frequency
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Duration
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                width: '28%',
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Instructions
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Prescribed by
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              End Date
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Action
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!medicationsListStatus
            ? medications?.map(row => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    {row.proprietaryname}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row.frequency}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row.duration} days
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row.instructions}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row.prescribed_by}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {moment(row.end_date).format('DD-MM-YYYY')}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {JSON.parse(localStorage.getItem('is_doctor'))?.is_doctor &&
                      !disabled && (
                        <>
                          <Link
                            className={
                              disabled || row.prescribed_by == ' '
                                ? classes.DisabledEditBtn
                                : classes.EditBtn
                            }
                            onClick={() => editClicked(row)}>
                            {disabled || row.prescribed_by == ' ' ? null : (
                              <EditIcon />
                            )}
                          </Link>
                          <Link
                            className={
                              disabled || row.prescribed_by == ' '
                                ? classes.DisabledDeleteBtn
                                : classes.DeleteBtn
                            }
                            onClick={() => deleteClicked(row)}>
                            {disabled || row.prescribed_by == ' ' ? null : (
                              <HighlightOff />
                            )}
                          </Link>
                        </>
                      )}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            : null}
        </TableBody>
      </Table>
      {medicationsListStatus ? (
        <Skeleton variant={'rect'} height={40} width={'100%'} />
      ) : null}
      {!medicationsListStatus && medications.length === 0 ? (
        <img
          src={NoRecordImg}
          className={classes.notFoundImage}
          alt={'Not found!'}
        />
      ) : null}
      <Box width="100%" display="flex" justifyContent="flex-end" p={2}>
        <Pagination
          count={totalPagesCurrent}
          shape="rounded"
          onChange={onPaginationClick}
        />
      </Box>
      <Box className={classes.InfoColTop}>
        <h3
          style={{
            marginTop: '30px',
            fontSize: 20,
            fontWeight: 500,
            color: '#000'
          }}>
          Medications History
        </h3>
      </Box>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell
              style={{
                width: '25%',
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Drug Name
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Frequency
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Duration
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Instructions
            </StyledTableCell>
            <StyledTableCell
              align="left"
              style={{
                backgroundColor: '#F5F5F5',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)'
              }}>
              Prescribed on
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!medicationsListStatus
            ? oldMedications?.map(row => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    {row.proprietaryname}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row.frequency}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row.duration}</StyledTableCell>
                  <StyledTableCell align="left">
                    {row.instructions}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {row.start_date}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            : null}
        </TableBody>
      </Table>
      <Box width="100%" display="flex" justifyContent="flex-end" p={2}>
        <Pagination
          count={totalPagesHistory}
          shape="rounded"
          onChange={onPaginationHM}
        />
      </Box>
      {medicationsListStatus ? (
        <Skeleton variant={'rect'} height={40} width={'100%'} />
      ) : null}
      {!medicationsListStatus && oldMedications.length === 0 ? (
        <img
          src={NoRecordImg}
          className={classes.notFoundImage}
          alt={'Not found!'}
        />
      ) : null}

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Patient's Document History" value="1" />
            <Tab label="Patient's Prescription" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Box className={classes.LabReport}>
            <Box
              display="flex"
              justifyContent="right"
              alignItems="center"
              mb={2}>
              {JSON.parse(localStorage.getItem('is_doctor'))?.is_doctor && (
                <button
                  disabled={disabled}
                  className={disabled ? classes.DisabledAddBtn : classes.AddBtn}
                  onClick={addLabOrdersClicked}>
                  Add New
                </button>
              )}
            </Box>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Report Name
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={classes.TableRow2}
                    style={{
                      width: '25%',
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Instructions
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Uploaded by
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Prescribed on
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Document
                  </StyledTableCell>
                  {/* <StyledTableCell
                align="left"
                className={classes.TableRow2}
                style={{
                  backgroundColor: '#F5F5F5',
                  fontSize: 13,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)'
                }}>
                Actions
              </StyledTableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {!labRecordsListStatus
                  ? Lab_data?.map(row => (
                      <StyledTableRow key={row.name}>
                        <StyledTableCell align="left">
                          {getTagValue(row.tags, 'testname') ||
                            `${row?.file_name}`.split('.')[0]}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {getTagValue(row.tags, 'instructions')}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.uploaded_by}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {moment(row.created_at).format('DD-MM-YYYY')}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Button
                            style={{
                              width: '70px',
                              height: '35px',
                              fontSize: '12px'
                            }}
                            // className={classes.AddBtn}
                            onClick={() => {
                              viewLabClicked(row.presigned_uri)
                              setPresigned(row.presigned_uri)
                            }}
                            disabled={row.presigned_uri == ''}
                            className={
                              row.presigned_uri == ''
                                ? classes.DisabledAddBtn
                                : classes.AddBtn
                            }>
                            View
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
            {labRecordsListStatus ? (
              <Skeleton variant={'rect'} height={40} width={'100%'} />
            ) : null}
            {!labRecordsListStatus && labRecords.length === 0 ? (
              <img
                src={NoRecordImg}
                className={classes.notFoundImage}
                alt={'Not found!'}
              />
            ) : null}
            <Box width="100%" display="flex" justifyContent="flex-end" p={2}>
              <Pagination
                count={lcTotalPage}
                shape="rounded"
                onChange={onLabPagination}
              />
            </Box>
          </Box>
        </TabPanel>
        <TabPanel value="2">
          <Box className={classes.LabReport}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Report Name
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Uploaded by
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Prescribed on
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    className={classes.TableRow2}
                    style={{
                      backgroundColor: '#F5F5F5',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)'
                    }}>
                    Document
                  </StyledTableCell>
                  {/* <StyledTableCell
                align="left"
                className={classes.TableRow2}
                style={{
                  backgroundColor: '#F5F5F5',
                  fontSize: 13,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)'
                }}>
                Actions
              </StyledTableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {!labRecordsListStatus
                  ? prescriptions?.map(row => (
                      <StyledTableRow key={row.name}>
                        <StyledTableCell
                          component="th"
                          scope="row"
                          // className={classes.TableRow2}
                        >
                          {`${row?.file_name}`.split('.')[0]}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.uploaded_by}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {moment(row.created_at).format('DD-MM-YYYY')}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Button
                            style={{
                              width: '70px',
                              height: '35px',
                              fontSize: '12px'
                            }}
                            // className={classes.AddBtn}
                            onClick={() => viewLabClicked(row.presigned_uri)}
                            disabled={row.presigned_uri == ''}
                            className={
                              row.presigned_uri == ''
                                ? classes.DisabledAddBtn
                                : classes.AddBtn
                            }>
                            View
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
            {labRecordsListStatus ? (
              <Skeleton variant={'rect'} height={40} width={'100%'} />
            ) : null}
            {!labRecordsListStatus && prescriptions.length === 0 ? (
              <img
                src={NoRecordImg}
                className={classes.notFoundImage}
                alt={'Not found!'}
              />
            ) : null}
            <Box width="100%" display="flex" justifyContent="flex-end" p={2}>
              <Pagination
                count={presTotal}
                shape="rounded"
                onChange={onPresPageChange}
              />
            </Box>
          </Box>
        </TabPanel>
      </TabContext>

      <AddMedicationModal
        open={addModal}
        handleClose={() => setAddModal(false)}
      />
      {editModal ? (
        <EditMedicationModal
          open={editModal}
          handleClose={() => setEditModal(false)}
          defaultValues={selectedMedication}
        />
      ) : null}

      {addLab ? (
        <AddLabOrders
          open={addLab}
          handleClose={() => {
            setAddLab(false)
          }}
          onSuccess={fetchLabData}
        />
      ) : null}

      {showEditLabModal ? (
        <EditLabOrders
          open={showEditLabModal}
          handleClose={() => setShowEditLabModal(false)}
          defaultValues={selectedLab}
        />
      ) : null}

      {viewRecordModal ? (
        <ViewLabRecordModal
          open={viewRecordModal}
          handleClose={() => setViewRecordModal(false)}
          record={selectedRecord}
          presigned={presigned}
        />
      ) : null}
    </>
  )
}

const useStyles = makeStyles(() => ({
  notFoundImage: {
    margin: '25px auto 0',
    display: 'flex',
    height: '200px',
    borderRadius: 20
  },
  InfoColTop: {
    width: '100%',
    marginTop: '15px',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h3': {
      fontSize: '15px',
      fontWeight: 600,
      color: '#505158',
      margin: 0
    }
  },
  AddBtn: {
    background: '#0D46C1',
    borderRadius: '8px',
    border: 'none',
    width: '100px',
    height: '35px',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '14px',
    color: '#fff',
    fontWeight: '500',
    cursor: 'pointer',
    textTransform: 'capitalize',
    '&:hover': {
      background: '#39415f !important'
    }
  },
  DisabledAddBtn: {
    background: '#A3A9B7',
    borderRadius: '8px',
    border: 'none',
    width: '115px',
    fontFamily: 'Poppins',
    height: '35px',
    textAlign: 'center',
    fontSize: '14px',
    color: '#fff',
    fontWeight: '500',
    cursor: 'pointer'
  },
  table: {
    minWidth: '100%',
    '@media (max-width:767px)': {
      width: '800px',
      overflowX: 'auto'
    }
  },
  EditBtn: {
    float: 'left',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    color: '#3f4b79',
    marginRight: '5px',
    '&:hover': {
      textDecoration: 'none',
      color: '#3f4b79',
      cursor: 'pointer'
    },
    '& img': {
      marginRight: '8px',
      float: 'left'
    }
  },
  DeleteBtn: {
    float: 'left',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    color: '#c10505',
    marginRight: '0',
    '&:hover': {
      textDecoration: 'none',
      color: '#c10505',
      cursor: 'pointer'
    },
    '& img': {
      marginRight: '8px',
      float: 'left'
    }
  },
  DisabledEditBtn: {
    float: 'left',
    color: 'grey',
    marginRight: '5px',
    '&:hover': {
      textDecoration: 'none',
      color: 'grey',
      cursor: 'pointer'
    },
    '& img': {
      marginRight: '8px',
      float: 'left'
    }
  },
  DisabledDeleteBtn: {
    float: 'left',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    color: 'grey',
    marginRight: '20px',
    '&:hover': {
      textDecoration: 'none',
      color: 'grey',
      curosr: 'pointer'
    },
    '& img': {
      marginRight: '8px',
      float: 'left'
    }
  },
  // LabReport: {
  //   marginTop: '40px'
  // },
  TableRow2: {
    borderBottom: '0px !important',
    padding: '7px 5px !important',
    fontFamily: 'Poppins'
  },
  TableRow: {
    background: '#fff !important',
    borderBottom: '0px !important',
    fontFamily: 'Poppins'
  }
}))

export default Medication
